import { UserRole } from "./domain/userRole";
import { Component } from "./presentation/Component";
import { redux } from "./redux";

const hasRole = (usersRoles: number[], rolesToCheck: UserRole[]) =>
  usersRoles.some((usersRole: number) => rolesToCheck.includes(usersRole));
  
export const moduleDefinition = {
  component: Component,
  redux,
  visibleOnNavigationBar: (user: any) => hasRole(user.roles, [ 3, 17 ])
};
